<template>
  <svg height="10" width="100%">
    <!-- Loading Svg Divider -->
    <line x1="0" y1="0" :x2="x2" y2="0" style="stroke: #fec627; stroke-width: 5" />
  </svg>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    x2: {
      type: String
    }
  }
});
</script>
